module.exports = __webpack_public_path__ + "img/header_welcome_to_use.9f661d74.svg";